import React, {lazy, FC, Suspense} from 'react'
import {ErrorBoundary} from '@ant-design/pro-components'
import {Route, Routes, Navigate, Outlet} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {PageTitle} from '../../_metronic/layout/core'
import {Soon} from '../modules/errors/components/Error404'
import MainLandingPage from '../../pages/MainLandingPage'
import FinanceReportsPage from '../../pages/reports/allReportsPages/FinanceReportsPage'
import ProductionReportsPage from '../../pages/reports/allReportsPages/ProductionReportsPage'
import HRReportsPage from '../../pages/reports/allReportsPages/HRReportsPage'
import EquipServiceReportsPage from '../../pages/reports/allReportsPages/EquipServiceReportsPage'
import SupplyChainReportsPage from '../../pages/reports/allReportsPages/SupplyChainReportsPage'

import CustomBreadCrumb from '../../constants/CustomBreadCrumb'
import CommonReportComponent from '../../constants/CommonReportComponent'
// const FinancePage = lazy(() => import('../pages/finance/FinancePage'))
// const ReportComponent = lazy(() => import('../reports/ReportComponent'))
// const HRDashboardWrapper = lazy(() => import('../pages/hr-payroll/HumanResourceDashBoard'))
// const SupplyChain = lazy(() => import('../pages/supplyChain/SupplyChain'))
// const ServiceManager = lazy(() => import('../pages/dashboard/DashboardWrapper'))
// const ProductionDashboardWrapper = lazy(
//   () => import('../pages/production/dashboard/ServiceManagerDashboardWrapper')
// )

const Devexpres = lazy(() => import('../pages/dashboard/Devexpres'))
const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        <Route path='auth/*' element={<Navigate to='/landing' />} />
        <Route path='auth/*' element={<Navigate to='/landing' />} />
        {/*<Route path='auth/*' element={<Navigate to='/report' />} />*/}
        {/*<Route path='auth/*' element={<Navigate to='/report' />} />*/}

        <Route
          path='/landing'
          element={
            <>
              <Suspense fallback={<TopBarProgress />}>
                <ErrorBoundary>
                  {/*<MainDashboardPage />*/}
                  <MainLandingPage/>
                </ErrorBoundary>
              </Suspense>
            </>
          }
        />

      <Route
          path='/finance-reports'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <FinanceReportsPage/>
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/production-reports'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <ProductionReportsPage/>
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/hr-reports'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <HRReportsPage/>
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/supplychain-reports'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <SupplyChainReportsPage/>
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/eqipservice-reports'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <EquipServiceReportsPage/>
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='payroll/*'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <Soon />
              </Suspense>
            </ErrorBoundary>
          }
        />

        {/*All DashBoard Routes*/}
        <Route
          path='/hr'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Human Resource'} isDashboard={true} isReport={false}/>
                <Devexpres dashboardId={'HRDashBoard'} />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/supply-chain-dashboard'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Supply Chain'} isDashboard={true} isReport={false}/>
                <Devexpres dashboardId={'SupplyChain'} />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/finance-dashboard/'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Finance'} isDashboard={true} isReport={false}/>
                <Devexpres dashboardId={'Finance'} />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/production-dashboard'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Production'} isDashboard={true} isReport={false}/>
                <Devexpres dashboardId={'pro_cycleDetails'} />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/equipservice-dashboard'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Equipment Service'} isDashboard={true} isReport={false}/>
                <Devexpres dashboardId={'equip-maintenance'} />
              </Suspense>
            </ErrorBoundary>
          }
        />

        {/*All Reports routes*/}
        <Route
          path='/production-update'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Production Update'} isDashboard={false} isReport={true} />
                <CommonReportComponent reportName="ProductionSummaryReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/production-pdt'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Production PTD'} isDashboard={false} isReport={true} />
                <CommonReportComponent reportName="ProductionPTDReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/production-progress'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
                <CustomBreadCrumb title={'Production Progress'} isDashboard={false} isReport={true} />
                <CommonReportComponent reportName="ProductionReport4" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/incident-register-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Incident Register Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="IncidentRegisterReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/fuel-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'FuelReport'} isDashboard={false} isReport={true} />
              <CommonReportComponent reportName="FuelReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/equipment-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Equipment Statistic'} isDashboard={false} isReport={true} />
              <CommonReportComponent reportName="EquipmentStatisticReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/activity-production'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Activity'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="ActivityReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        
        <Route
          path='/equipment-list-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Equipment List Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="ListEquipmentSummary" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/backlog-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Backlog Summary'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="AllBacklogsReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

         <Route
          path='/faulty-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Faulty Summary'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="FaultEntrySummaryReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/activity-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Activity'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="ActivityReport1" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/age-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Age Profile'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="EmployeeAgeSummaryReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/leave-summary-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Leave Summary'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="LeaveSummaryReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/department-summary-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Department Summary'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="LeaveDepartmentReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/employee-list-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Employee List Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="EmployeeListReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/drill-statistic-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Drill Statistics Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="DrillStatisticsReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

       <Route
          path='/trial-balance-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Trial Balance Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="TrialBalanceReport" />
              </Suspense>
            </ErrorBoundary>
          }
        />

        <Route
          path='/accounts-payable-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Accounts Payable Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="AccountsPayable" />
              </Suspense>
            </ErrorBoundary>
          }
        />

      <Route
          path='/accounts-receivable-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Accounts Receivable Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="AccountsReceivable" />
              </Suspense>
            </ErrorBoundary>
          }
        />

       <Route
          path='/fixed-assets-report'
          element={
            <ErrorBoundary>
              <Suspense fallback={<TopBarProgress />}>
              <CustomBreadCrumb title={'Fixed Assets Report'} isDashboard={false} isReport={true} />
                {/* <IncidentRegisterReport /> */}
                <CommonReportComponent reportName="FixedAssets" />
              </Suspense>
            </ErrorBoundary>
          }
        />


        <Route
          path='svc-manager/*'
          element={
            <Suspense fallback={<TopBarProgress />}>
              <PageTitle>{'Service Manager Dashboard'}</PageTitle>
              {/*<ServiceManager />*/}
              <Devexpres dashboardId={'dashboard3'} />
            </Suspense>
          }
        />

        <Route
          path='svc-manager/*'
          element={
            <Suspense fallback={<TopBarProgress />}>
              <PageTitle>{'Service Manager Dashboard'}</PageTitle>
              {/*<ServiceManager />*/}
              <Devexpres dashboardId={'dashboard3'} />
            </Suspense>
          }
        />

        {/*<Route*/}
        {/*  path='svc-manager/*'*/}
        {/*  element={*/}
        {/*    <Suspense fallback={<TopBarProgress />}>*/}
        {/*      <PageTitle>{'Service Manager Dashboard'}</PageTitle>*/}
        {/*      /!*<ServiceManager />*!/*/}
        {/*      <Devexpres dashboardId={'dashboard3'} />*/}
        {/*    </Suspense>*/}
        {/*  }*/}
        {/*/>*/}
        {/* Page Not Found */}

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
